exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_info strong {\n  padding-bottom: 10px;\n}\n.box_info span {\n  padding-bottom: 10px;\n}\n.loading {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%);\n}\n.cursor_pointer {\n  border: 1px solid;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/stamp_list_mb/find-stamp-mb-by-serial.component.css
// module id = ../../../../../src/app/pages/admin/evs/stamp_list_mb/find-stamp-mb-by-serial.component.css
// module chunks = 3